/*jshint esversion: 6 */

// const autoprefixer = require("autoprefixer");

var supportsTouch = 'ontouchstart' in window || navigator.msMaxTouchPoints;

var site = {};
var config = {
  layoutD: ['-1vw', '7vw', '-4vw', '2vw'],
  layoutM: ['-1vw', '1vw', '-1vw', '1vw'],
  audio: true,
  screening: false,
  players: [],
  directorsLink: document.getElementById('directors-link'),
  closeDirectors: document.getElementById('close-directors-link'),
  directorsClip : document.getElementById('directors-clip'),
  scrollPos: 0,
};

var elements = [];

(function() {
  "use strict";


  this.hideVideo = function(e){
    
      let elm = document.body.getElementsByClassName('active-video')[0];
      let index = elm.dataset.index;
      let obj = config.videos[index];


      let wrap = obj.wrap;
      let parent = wrap.parentNode;
      obj.elm.pause();
      obj.elm.setAttribute('playsinline', true);

      wrap.classList.add('closeing');
    
      obj.elm.muted = true;
      obj.playing = false;

      wrap.classList.remove('ready');
      
      document.body.classList.remove('video-playing');

      let rect = parent.getBoundingClientRect();

      let per = 100/config.videos.length;

      gsap.to(elm, {
        duration: 0.6,
        transform: "translate(0,0)",
        scale: 1.5,
      });


      if( window.innerWidth > 900 || window.innerWidth > window.innerHeight ){
        let top = 'calc(-50% + ' + config.layoutD[index] +')';
        gsap.to( wrap, {
          left: (per * index) + '%',
          width: per + '%' ,
          transform: 'translateY('+top+')',
          top: 'calc(50% + 4vw)',
          duration: 0.6,
          padding: '0px',
          ease: "power1.inOut",
          onComplete:function(){
            document.body.classList.remove('video-active');
            obj.elm.classList.remove('active-video');
            wrap.classList.remove('active');
            config.screening = false;
            obj.active = false;
            obj.elm.src = obj.elm.dataset.small;
            obj.elm.pause();

            // if(window.innerWidth > 900){
              obj.animation.resume();
            // }
            wrap.classList.remove('closeing');
          }
        });
      }else{
       
        let left = 'calc(-50% + ' + config.layoutM[index] +')';
        gsap.to( wrap, {
          height: per + '%' ,
          transform: 'translateX(-50%)',
          left: '50%',
          x: 0,
          y: 0,
          width: '',
          top: (per * index) + '%',
          duration: 0.6,
          padding: '0px',
          ease: "power1.inOut",
          onComplete:function(){
            document.body.classList.remove('video-active');
            obj.elm.classList.remove('active-video');
            wrap.classList.remove('active');
            config.screening = false;
            obj.active = false;
            obj.elm.src = obj.elm.dataset.small;
            obj.animation.resume();
            wrap.classList.remove('closeing');
          }
        });
      }
  }

  this.videos = function(){

    let videoWraps = document.getElementsByClassName('video--player');
    let iframes = document.querySelector('iframe');
    let previews = document.getElementsByClassName('has-preview');


    config.players = [];

    for (let i = 0; i < videoWraps.length; i++) {

      let wrap = videoWraps[i];
      let player = wrap.querySelector('.player');



      let data = {
        wrap: wrap,
        player: player
      };
      

      wrap.style.opacity = 1;

      wrap.addEventListener('click', playVideo);

      config.players.push(data);
    }

    for (let i = 0; i < previews.length; i++) {
      previews[i].addEventListener('mouseover', showPreivew);
      previews[i].addEventListener('mouseleave', hidePreview);
    }

    function showPreivew(e){

      let elm = this;
      let video = elm.getElementsByTagName('video')[0];
      let img = elm.getElementsByTagName('img')[0];



      if(img){
        
        if(!elm.dataset.loaded){
          elm.dataset.loaded = true;
          video.src = video.dataset.src;
        }

        showPreview(elm)
        
      }
    
    };

    function showPreview(elm){

      let video = elm.getElementsByTagName('video')[0];
      let img = elm.getElementsByTagName('img')[0];

      img.style.opacity = 0;

      video.loop = true;
      video.play();

    };

    function hidePreview(){

      let elm = this;
      let video = elm.getElementsByTagName('video')[0];
      let img = elm.getElementsByTagName('img')[0];

      if(img){
        img.style.opacity = 1;
        video.pause();
      }

    };


    function playVideo(e, wrap){
      
      let elm = this;
    
      for (let i = 0; i < config.players.length; i++) {

        if(elm === config.players[i].wrap){

          if(!config.players[i].video){

            
            const options = {
                url: config.players[i].player.dataset.id,
                resoponsive: true,
                controls: true,
                playsinline: true,
                autopause: true,
                muted: false,
                color: 'ffffff',
                dnt: true
            };

            config.players[i].video = new Vimeo.Player(config.players[i].player, options);
          
            config.players[i].video.on('play', function() {
              // console.log('Played the video');
            });

            config.players[i].video.on('ended', function() {
              wrap.classList.remove('playing');
              video.pause();
            });

            config.players[i].video.on('pause', function() {
              wrap.classList.remove('playing');
            });

          }

          config.players[i].wrap.classList.add('playing');
          config.players[i].video.play();
          
        }else{
          config.players[i].wrap.classList.remove('playing');
          if(config.players[i].video){
            config.players[i].video.pause();
          }
        }
      }
      
    };
    
  };

  this.turbo_load = function(){

    let articles = document.getElementsByTagName('article');
    let header = document.querySelector('header');
    let splash = document.querySelector('.splash-ready');

    if(articles.length < 1){
      articles = document.querySelectorAll('.video--container');
    }



    for (let a = 0; a < articles.length; a++) {

      // if(splash){
       
      //   setTimeout(function(){
      //     articles[a].style.opacity = 1;
      //     header.style.opacity = 1;
      //   }, 3300);

      // }else{

        header.style.opacity = 1;
        
        window.scrollTo(0,0)
        
        setTimeout(function(){
          articles[a].style.opacity = 1;
        }, 50);
        
      // }

    
    }

    let vids = document.querySelectorAll('.video--player, .gallery--block');
    // console.log('trig');
    for (let a = 0; a < vids.length; a++) {
      stargger_load(vids[a], a); 
    }

    function stargger_load(elm, a){
      setTimeout(function(){
        elm.style.opacity = 1;
      }, 200 * a);
    };

  };

  this.stop_videos = function(){
    for (let i = 0; i < config.players.length; i++) {
      config.players[i].wrap.classList.remove('playing');
      config.players[i].video.pause();
    }
  };

  this.directors = function(){

    if(config.directorsLink){

      config.directorsLink.addEventListener('click', showDirectors);
      config.closeDirectors.addEventListener('click', hideDirectors);


      function showDirectors(e){
        e.preventDefault();

        // config.directorsClip.classList.add('open');
        document.body.classList.add('hide-overflow');
        
        site.stop_videos();
        
        
      };

      

      function hideDirectors(e){
        e.preventDefault();

        // config.directorsClip.classList.remove('open');
        document.body.classList.remove('hide-overflow');
      }
      

    }

    if(config.directorsLinks.length){

      for (let a = 0; a < config.directorsLinks.length; a++) {
        let elm = config.directorsLinks[a];
        elm.addEventListener('mouseover', showPreview);
        
      }

  
    }

    function showPreview(e){

      var elm = this;

      if(!elm.classList.contains('loaded')){

        elm.classList.add('loaded');
        let img = elm.getElementsByTagName('img')[0];
        let video = elm.getElementsByTagName('video')[0];

        if(img){
          img.src = img.dataset.src;
        }
        if(video){
          video.src = video.dataset.src;
        }

      
      }

    }

  };

  this.mob_menu = function(){

    let triggers = document.getElementsByClassName('mob-menu');

    for (let i = 0; i < triggers.length; i++) {
       triggers[i].addEventListener('click', toggleMobMenu);
    }

    function toggleMobMenu(e){
      e.preventDefault();
      document.body.classList.toggle('menu-open');
    }

  };
  
  this.roster_filter = function(){

    var rosterFilters = document.querySelectorAll('.roster-filter');



    for (let a = 0; a < rosterFilters.length; a++) {
      let elm = rosterFilters[a];
      elm.addEventListener('click', function(e){
        e.preventDefault();
        let elm = this;
        let activeSlug = elm.dataset.slug;
        setCookie('active_filter',activeSlug, 10);

        if (window.location.href.indexOf("rosters") > -1) {
          window.history.replaceState('Object', elm.innerHTML , `/rosters/${activeSlug}`);
        }

        filterClick(elm, activeSlug);

      });
    }
    
    var pre_active = false;

    if (window.location.href.indexOf("rosters") > -1) {
      let parts = window.location.href.split('/');
      let lastSegment = parts.pop() || parts.pop(); 
      let link = document.querySelector(`[data-slug="${lastSegment}"]`);
      if(link){
        setCookie('active_filter',lastSegment, 10);
      }
    }else{
        pre_active = getCookie('active_filter');
    }

   
    if(pre_active){
      let elm = document.querySelector(`[data-slug="${pre_active}"]`);
      let activeSlug = pre_active;
      filterClick(elm, activeSlug);
    }


    function filterClick(elm, activeSlug){

      let wrap = elm.parentNode.parentNode.parentNode;
      let sibs = document.querySelectorAll('.roster-filter');

      if(!elm.classList.contains('active')){
       
        for (let a = 0; a < sibs.length; a++) {
          let elm = sibs[a];
          elm.classList.remove('active');  
        }

        let aList = document.querySelectorAll('.active-list');
        
        for (let a = 0; a < aList.length; a++) {
          let elm = aList[a];
          elm.style.opacity = 0;  
          setTimeout(function(){
            elm.style.display = 'none';  
          }, 300);
        }

        let cl = '.'+activeSlug+'-wrap';
        let newList = document.querySelectorAll(cl);
    

        setTimeout(function(){
          for (let a = 0; a < newList.length; a++) {
            let elm = newList[a];
            elm.style.display = 'flex';
            setTimeout(function(){
              elm.style.opacity = 1;
            }, 50);
            elm.classList.add('active-list');
          }
        }, 400);

        
        let links = document.querySelectorAll(`[data-slug="${activeSlug}"]`);
        for (let a = 0; a < links.length; a++) {
          links[a].classList.add('active');          
        }


      }
        
    };

  };


  this.slide_shows = function(){

    var swipers = document.getElementsByClassName('swiper');
    if(swipers.length){
      
      var swiper = new Swiper('.swiper', {
        speed: 400,
        loop: true,
        centeredSlides: true,
        spaceBetween: 100,  
        slidesPerView: 'auto',
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      });
    }

  };
  
    this.add_class_when_visible = function() {
      
      elements = document.querySelectorAll('.lazy-view');

      let options = {
          root: null, // relative to document viewport 
          rootMargin: '0px', // margin around root. Values are similar to css property. Unitless values not allowed
          threshold: 0.05 // visible amount of item shown in relation to root
      };

      let observer = new IntersectionObserver(function (entries, observer) { 
          entries.forEach(entry => {
            if(entry && entry.boundingClientRect.top !== null && entry.rootBounds && entry.rootBounds.top !== null){
              if (entry.isIntersecting) {
                  entry.target.classList.add('visible');
                  entry.target.classList.add('pos');
                  entry.target.classList.remove('above', 'below');
              } else {
                  entry.target.classList.remove('pos');
                  if (entry.boundingClientRect.top < entry.rootBounds.top) {
                    // It is above, remove class "below" if it exists and add class "above"
                    entry.target.classList.remove('below');
                    entry.target.classList.add('above');
                } else {
                    // It is below, remove class "above" if it exists and add class "below"
                    entry.target.classList.remove('above');
                    entry.target.classList.add('below');
                }
              }
            }

          });
      }, options);

      elements.forEach(element => {
          observer.observe(element);
      });
  }


  this.load_in = function(){

    // let splash = document.querySelector('.splash');
    // let article = document.querySelector('article');

    // if(splash){
    //   splash.classList.add('ready');
    // }

  };

  this.header_scroll = function(e){
   
        
      if(window.scrollY > 100 ){
        document.querySelector('header').classList.add('solid-bg');
      }else{
        document.querySelector('header').classList.add('solid-bg');
      }

      if(window.scrollY > 100 && config.scrollPos < window.scrollY ){
        document.querySelector('header').classList.add('hidden');
      }else{
        document.querySelector('header').classList.remove('hidden');
      }

      config.scrollPos = window.scrollY;

  }

  this.start = function(){

      config = {
        layoutD: ['-1vw', '7vw', '-4vw', '2vw'],
        layoutM: ['-1vw', '1vw', '-1vw', '1vw'],
        audio: true,
        screening: false,
        players: [],
        directorsLink: document.getElementById('directors-link'),
        closeDirectors: document.getElementById('close-directors-link'),
        directorsClip : document.getElementById('directors-clip'),
        directorsLinks: document.getElementsByClassName('director-link')
      };
      
      site.videos();
      site.directors();
      site.mob_menu();
      site.slide_shows();
      site.turbo_load();
      site.roster_filter();
      site.add_class_when_visible();

      document.removeEventListener('scroll', site.header_scroll);
      document.addEventListener('scroll', site.header_scroll);

      createObserver();
  };

})
.apply(site);


document.addEventListener("DOMContentLoaded", function () {

  

  var splash = document.querySelector('.splash');

  if(splash){
    splash.classList.add('ready');
    splash.classList.add('splash-ready');

    splash.addEventListener("click", function(){
        // splash.style.opacity = 0;
        splash.classList.add('animate');
        setTimeout(function(){
          splash = document.querySelector('.splash');
          if(splash){
            splash.classList.remove('splash-ready');
          }
        }, 500);
        setTimeout(function(){
          splash = document.querySelector('.splash');
          if(splash){
           splash.parentNode.removeChild(splash);
          }
        }, 1500);

    }, false);

    setTimeout(function(){
      splash = document.querySelector('.splash');
      
      if(splash){
        splash.classList.add('animate');
        setTimeout(function(){
          splash = document.querySelector('.splash');
          if(splash){
            splash.classList.remove('splash-ready');
          }
        }, 500);
        setTimeout(function(){
         splash = document.querySelector('.splash');
         if(splash){
          splash.parentNode.removeChild(splash);
         }
        }, 1500);
      }

    }, 3000 );
  }


});


document.addEventListener("turbo:load", site.start);

document.addEventListener("turbo:click", function(event) {

    // config.directorsClip.classList.remove('open');
    
    let articles = document.querySelectorAll('article');
    for (let a = 0; a < articles.length; a++) {
      articles[a].style.opacity = 0;
    }
  
});


function getRandomArbitrary(min, max) {
  return Math.round(Math.random() * (max - min) + min);
}

window.addEventListener('resize', function(){
   
});

function createObserver() {
  let observer;

  let options = {
    root: null,
    rootMargin: "0px",
    threshold: buildThresholdList()
  };

  observer = new IntersectionObserver(handleIntersect, options);
  
  var vids = document.getElementsByClassName('video--player');

  for (let index = 0; index < vids.length; index++) {
    var box = vids[index];
    observer.observe(box);   
  }

}

function buildThresholdList() {
  let thresholds = [];
  let numSteps = 20;

  for (let i=1.0; i<=numSteps; i++) {
    let ratio = i/numSteps;
    thresholds.push(ratio);
  }

  thresholds.push(0);
  return thresholds;
}


function handleIntersect(entries, observer) {
  entries.forEach((entry) => {

    if(entry.target.querySelector('video')){
      if(entry.target.querySelector('video').src.length < 1){
        entry.target.querySelector('video').src = entry.target.querySelector('video').dataset.src;
      }
    }

    if (entry.intersectionRatio > 0.5) {
      entry.target.classList.add('onscreen');
    } else {
      entry.target.classList.remove('onscreen');
    }
  });
}



function setCookie(name,value,days) {
  var expires = "";
  if (days) {
      var date = new Date();
      date.setTime(date.getTime() + (days*24*60*60*1000));
      expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}
function getCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  for(var i=0;i < ca.length;i++) {
      var c = ca[i];
      while (c.charAt(0)==' ') c = c.substring(1,c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
  }
  return null;
}
function eraseCookie(name) {   
  document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}